import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import * as types from '../actionTypes/PhoneVerificationActionTypes';

export const initialState = {
    isSliderOpen: false,
    firstName: '',
    phoneNumber: '',
    phoneSliderState: '',
    resendEnable: true,
    resentSuccess: false,
    error: {},
    requestOTPDetails: {
        success: false,
    },
    verifyOTPDetails: {
        success: false,
    },
    onPhoneVerificationSuccess: null,
    onPhoneVerificationStop: null,
};

// const initialState = {
//     DEFAULT: {},
// };

function PhoneVerificationReducer(state = initialState, action = {}) {
    switch (action.type) {
        case types.START_PHONE_VERIFY: {
            const newState = {};
            newState.phoneSliderState = action.payload.sliderStatus;
            newState.phoneNumber = action.payload.phoneNumberWithAlreadyOTP || '';
            // only when payload has callback functions
            // then store in redux
            action.payload.onPhoneVerificationSuccess &&
                (newState.onPhoneVerificationSuccess = action.payload.onPhoneVerificationSuccess);
            action.payload.onPhoneVerificationStop &&
                (newState.onPhoneVerificationStop = action.payload.onPhoneVerificationStop);
            newState.firstName = TokenProvider.get('DP_USER_NAME');
            newState.mountVerifyPhoneSlider = action.payload.isSliderOpen;
            newState.isSliderOpen = action.payload.isSliderOpen;
            newState.resendEnable = true;
            newState.resentSuccess = false;
            newState.error = {};
            return { ...state, ...newState };
        }
        case types.POST_REQUEST_OTP: {
            const { phoneNumber } = action.payload;
            const requestOTPDetails = {
                ...state.requestOTPDetails,
                isLoading: true,
            };
            const resentSuccess = false;
            const resendEnable = false;
            return { ...state, phoneNumber, requestOTPDetails, resendEnable, resentSuccess };
        }
        case types.STOP_OTP_REQUEST: {
            // reset to initial state
            // only retain onSuccess & onSkip callbacks
            const { onPhoneVerificationSuccess } = state;
            const { onPhoneVerificationStop } = state;
            // stored in new state
            const newState = {
                ...initialState,
                phoneSliderState: state.phoneSliderState,
                onPhoneVerificationStop,
                onPhoneVerificationSuccess,
            };
            return { ...state, ...newState };
        }
        case types.VERIFY_PHONE_SLIDER_UNMOUNT: {
            return { ...state, mountVerifyPhoneSlider: false };
        }
        case types.POST_REQUEST_OTP_SUCCESS: {
            const requestOTPDetails = {
                ...state.requestOTPDetails,
                isLoading: false,
                success: true,
            };
            const phoneSliderState = 'VERIFY_OTP';

            const { isReSendRequest, phoneNumber } = action.payload;

            const resentSuccess = isReSendRequest || false;
            const error = {};
            return {
                ...state,
                mountVerifyPhoneSlider: true,
                isSliderOpen: true,
                requestOTPDetails,
                phoneSliderState,
                error,
                phoneNumber,
                resentSuccess,
            };
        }
        case types.POST_REQUEST_OTP_ERROR: {
            const requestOTPDetails = {
                ...state.requestOTPDetails,
                isLoading: false,
                success: false,
            };
            const error = action.payload || {};
            //  Hide slider if error says phone number is landline
            return { ...state, requestOTPDetails, error, isSliderOpen: !action.isLandlineError };
        }
        case types.POST_VERIFY_OTP: {
            const verifyOTPDetails = {
                ...state.verifyOTPDetails,
                isLoading: true,
            };
            return { ...state, verifyOTPDetails };
        }
        case types.POST_VERIFY_OTP_SUCCESS: {
            const verifyOTPDetails = {
                ...state.verifyOTPDetails,
                isLoading: false,
                success: true,
            };
            const error = {};
            const phoneSliderState = 'PHONE_VERIFY_OK';
            return { ...state, verifyOTPDetails, error, phoneSliderState };
        }
        case types.POST_VERIFY_OTP_ERROR: {
            const verifyOTPDetails = {
                ...state.verifyOTPDetails,
                isLoading: false,
                success: false,
            };
            const error = action.payload || {};
            return { ...state, verifyOTPDetails, error };
        }
        case types.ENABLE_RESEND_OTP: {
            const resendEnable = true;
            return { ...state, resendEnable };
        }
        case types.PHONE_VERIFY_CLEAR_CALLBACKS: {
            return { ...state, onPhoneVerificationSuccess: null, onPhoneVerificationStop: null };
        }
        default:
            return state;
    }
}
PhoneVerificationReducer.reducerName = 'phoneVerification';
export default PhoneVerificationReducer;
